import React from "react";
import fieldPropTypes from "../field-prop-types";

const isChecked = (field, value) => {
  const selectedOption = field.options.find(option =>
    value ? option.value === value : option.selected
  );

  return selectedOption && selectedOption.name === "Y";
};

const ModernizedToggle = ({
  field,
  components: { ModernizedToggle: ToggleComponent },
  appData
}) => {
  const handleSwitchChange = () => {
    const checked = isChecked(field, appData.values[field.name]) || false;

    const selectedOption = field.options.find(option =>
      !checked ? option.name === "Y" : option.name === "N"
    );

    appData.handleSwitchChange(field.name, selectedOption);

    field.options.forEach(option => {
      option.selected = !option.selected;
    });
  };

  return (
    <ToggleComponent
      field={{
        ...field,
        defaultChecked: isChecked(field, appData.values[field.name]) || false,
        onChange: handleSwitchChange
      }}
    />
  );
};

ModernizedToggle.propTypes = fieldPropTypes;

export default ModernizedToggle;
